import { Chip, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { useCurrentOrg } from "~/providers/GraphqlProvider";
import { CommandCenterLocationState } from "./DateSelector";
import { visitResourceNeedsAttention } from "~/utils/visitsHelper";
import { useTodaysVisits } from "~/providers/TodaysVisitsProvider";

const VirtualVisitsCount = () => {
  const navigate = useNavigate();
  const providerId = useCurrentOrg()?.providerId;

  const { visitResources } = useTodaysVisits();
  const needAttention = visitResources.filter(vr => visitResourceNeedsAttention(vr, providerId));
  const count = needAttention.length;

  if (!count) { return null; }

  const state: CommandCenterLocationState = {
    date: new Date(needAttention[0].startTime),
    visitResourceId: needAttention[0].id,
  };

  return <Tooltip title={`${count === 1 ? "A visit is" : (count + " visits are")} ready for you to join`}>
    <Chip color="primary" label={count} size="small" onClick={(e) => {
      navigate("/command", { state, replace: true });
      e.preventDefault();
    }}/>
  </Tooltip>
}

export default VirtualVisitsCount;
